module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor"
  }, [_c('el-form', {
    ref: "newPost",
    attrs: {
      "model": _vm.newPost,
      "rules": _vm.rules,
      "label-position": "top",
      "label-width": "100px"
    }
  }, [_c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingUpdate),
      expression: "loadingUpdate"
    }],
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "專案名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "3至15字元",
      "width": "100%",
      "size": "small"
    },
    model: {
      value: (_vm.newPost.name),
      callback: function($$v) {
        _vm.newPost.name = $$v
      },
      expression: "newPost.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "桌號",
      "prop": "table"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "請選擇目前所在桌號",
      "size": "small"
    },
    model: {
      value: (_vm.newPost.table),
      callback: function($$v) {
        _vm.newPost.table = $$v
      },
      expression: "newPost.table"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "尋找中",
      "value": "0"
    }
  }), _vm._v(" "), _vm._l((_vm.tables), function(i) {
    return (i !== '0') ? _c('el-option', {
      key: i,
      attrs: {
        "label": i + '桌',
        "value": i
      }
    }) : _vm._e()
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企業獎調查（至多2個，調查至3pm截止，詳細流程：https://goo.gl/oWutMs）",
      "prop": "awards"
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "min": 0,
      "max": 2
    },
    model: {
      value: (_vm.newPost.awards),
      callback: function($$v) {
        _vm.newPost.awards = $$v
      },
      expression: "newPost.awards"
    }
  }, _vm._l((_vm.awardOptions), function(awardOpt) {
    return _c('el-checkbox', {
      key: awardOpt,
      attrs: {
        "label": awardOpt,
        "disabled": false
      }
    }, [_vm._v(_vm._s(awardOpt))])
  }))], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "與會者編號",
      "prop": "host"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top",
      "visible-arrow": true,
      "content": "格式：#999"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "placeholder": "提案人"
    },
    model: {
      value: (_vm.newPost.host),
      callback: function($$v) {
        _vm.newPost.host = $$v
      },
      expression: "newPost.host"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "專案成員",
      "prop": "teammates"
    }
  }, [_vm._l((_vm.newPost.teammates), function(teammate) {
    return _c('el-tag', {
      key: teammate,
      attrs: {
        "closable": true,
        "type": "gray",
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleDeleteTeammate(teammate)
        }
      }
    }, [_vm._v(_vm._s(teammate))])
  }), _vm._v(" "), (_vm.inputVisibleTeammate) ? _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newPost.teammates || _vm.newPost.teammates.length < 15),
      expression: "!newPost.teammates || newPost.teammates.length < 15"
    }],
    ref: "saveTeammateInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": _vm.handleNewTeammateConfirm
    },
    nativeOn: {
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleNewTeammateConfirm($event)
      }
    },
    model: {
      value: (_vm.inputNewTeammate),
      callback: function($$v) {
        _vm.inputNewTeammate = $$v
      },
      expression: "inputNewTeammate"
    }
  }) : _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newPost.teammates || _vm.newPost.teammates.length < 15),
      expression: "!newPost.teammates || newPost.teammates.length < 15"
    }],
    staticClass: "button-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.showNewTeammateInput
    }
  }, [_vm._v("+ 新增成員")])], 2)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "專案聯絡方式（公開）",
      "prop": "contact"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Discord ID, 臉書, email等，自由選填，多筆請以逗號分隔"
    },
    model: {
      value: (_vm.newPost.contact),
      callback: function($$v) {
        _vm.newPost.contact = $$v
      },
      expression: "newPost.contact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "標籤",
      "prop": "tags"
    }
  }, [_vm._l((_vm.newPost.tags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": true,
        "type": "gray",
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleDeleteTag(tag)
        }
      }
    }, [_vm._v(_vm._s(tag))])
  }), _vm._v(" "), (_vm.inputVisible) ? [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "value": _vm.tagListTooltip.length > 0,
      "placement": "right-start",
      "visible-arrow": true
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.tagListTooltip)
    },
    slot: "content"
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newPost.tags || _vm.newPost.tags.length < 3),
      expression: "!newPost.tags || newPost.tags.length < 3"
    }],
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": _vm.handleNewTagConfirm
    },
    nativeOn: {
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleNewTagConfirm($event)
      }
    },
    model: {
      value: (_vm.inputNewTag),
      callback: function($$v) {
        _vm.inputNewTag = $$v
      },
      expression: "inputNewTag"
    }
  })], 1)] : _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newPost.tags || _vm.newPost.tags.length < 3),
      expression: "!newPost.tags || newPost.tags.length < 3"
    }],
    staticClass: "button-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.showNewTagInput
    }
  }, [_vm._v("+ 新增標籤")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "進度狀態",
      "prop": "status"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.newPost.status),
      callback: function($$v) {
        _vm.newPost.status = $$v
      },
      expression: "newPost.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "徵人"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "趕工"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "完工"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "放棄"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "企業獎",
      "prop": "award"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.newPost.award),
      callback: function($$v) {
        _vm.newPost.award = $$v
      },
      expression: "newPost.award"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "無"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "中信金控"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "北市交通局"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "微軟"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "HITCON"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "經濟部"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "農委會"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "威盛電子"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.wordCountMsg,
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "width": "20rem",
      "placeholder": "請簡要介紹專案內容（100字以內，約前30字會顯示於卡片預覽）"
    },
    model: {
      value: (_vm.newPost.desc),
      callback: function($$v) {
        _vm.newPost.desc = $$v
      },
      expression: "newPost.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "GitHub",
      "prop": "git"
    }
  }, [_c('el-input', {
    staticClass: "url",
    attrs: {
      "placeholder": "john666/my-project"
    },
    model: {
      value: (_vm.newPost.git),
      callback: function($$v) {
        _vm.newPost.git = $$v
      },
      expression: "newPost.git"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("github.com/")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "專案介紹 URL",
      "prop": "iframe"
    }
  }, [_c('el-input', {
    staticClass: "url",
    attrs: {
      "placeholder": "請輸入可預覽之網頁網址（下方可測試）"
    },
    on: {
      "change": function($event) {
        _vm.loadIframe = false;
        _vm.isLoadingIframe = false
      }
    },
    model: {
      value: (_vm.newPost.iframe),
      callback: function($$v) {
        _vm.newPost.iframe = $$v
      },
      expression: "newPost.iframe"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "body-style": {
        padding: '0px'
      }
    }
  }, [(!_vm.loadIframe) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.loadIframe = true;
        _vm.isLoadingIframe = true
      }
    }
  }, [_vm._v("測試 URL 預覽")]) : _vm._e(), _vm._v(" "), (_vm.isLoadingIframe) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }]
  }, [_vm._v("\n               "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.loadIframe) ? _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoadingIframe),
      expression: "!isLoadingIframe"
    }],
    attrs: {
      "src": _vm.newPost.iframe,
      "width": "100%",
      "height": "100%"
    },
    on: {
      "load": function($event) {
        _vm.isLoadingIframe = false
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v("已知支援預覽：\n            "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://hackmd.io/new"
    }
  }, [_vm._v("HackMD")]), _vm._v("、\n            "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.google.com.tw/intl/zh-TW/docs/about/"
    }
  }, [_vm._v("Google Doc")]), _vm._v("、\n            "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.youtube.com/"
    }
  }, [_vm._v("YouTube")])])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('newPost')
      }
    }
  }, [_vm._v("更新")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$emit('cancel')
      }
    }
  }, [_vm._v("取消")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f5f7199"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/hackingmap/Editor.vue
// module id = 960
// module chunks = 1